module.exports = "<div ng-form=$ctrl.railCardsForm><div class=\"panel panel-default\" ng-repeat=\"passenger in $ctrl.model.passengersRailcards\"><div class=panel-body><span style=color:#000><l10n>Passenger</l10n>&nbsp;{{$index + 1}}</span> <button type=button class=\"btn btn-primary\" kt-eu-rail-railcards-modal=\"\" kt-eu-rail-railcards-modal-passenger=passenger>+<l10n>Add</l10n></button> <button type=button class=btn ng-repeat=\"card in passenger.cards\" ng-click=\"$ctrl.editCard(card, passenger)\">{{card.type.Name}}</button></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/eurail-cards/eurail-cards.html
// module id = 826
// module chunks = 0